/// <amd-module name="Artifacts/Sample/redux/Reducer" />

import { SampleActionTypes, SimpleActionUnion } from "Artifacts/Sample/redux/Actions";
import { ISampleComponentState } from "Artifacts/Sample/redux/Contracts";
import produce from "immer";

const initialState = (): ISampleComponentState => ({ hello: "" });

export const sampleReducer = produce((draft: ISampleComponentState, action: SimpleActionUnion) => {
  switch (action.type) {
    case SampleActionTypes.HelloWorld:
      draft.hello = "Hello, Sample World!";
      break;
  }
  return draft;
}, initialState());
